import styled from 'styled-components'

export const SidebarContainer = styled.div`
    width: 100%;
    display: grid;
    align-self: start;
    justify-items: center;
    background-color: #fff;
    padding: 20px;
    border-radius: 5px;
    overflow: hidden;
    grid-gap: 20px;
    margin-top: 20px;
    max-height: 349px;
    overflow-y: auto;
`